import axios from 'axios';
import store from '@/store';
import endpointVersion from '@/helpers/endpoint-version';

export const getApprovalList = ({ fileType, responseType, page, limit, orderBy, actionId, term, status }) => {
  const brand = store.getters.selectedBrand;
  const tokenV3 = store.state.auth.tokenV3;

  return axios.get('/action/getApprovalList', {
    baseURL: endpointVersion('v3'),
    params: {
      brand: brand.id,
      format: fileType,
      actionId,
      page,
      limit,
      orderBy,
      term,
      status,
    },
    responseType,
    headers: { Authorization: `Bearer ${tokenV3}` },
  });
};
